// src/features/auth/constants.js
export const AUTH_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
/** Tiempo en ms tras guardar el token durante el cual no se hace refresh proactivo (evita "Session Expired" mientras auth/refresh en AWS devuelve 403). */
export const LAST_TOKEN_SET_GRACE_MS = 60 * 60 * 1000; // 1 hora
export const LAST_TOKEN_SET_KEY = 'lastTokenSetAt';
export const AUTH_HEADER = 'Authorization';
export const AUTH_SCHEME = 'Bearer';
export const AUTH_PATHS = {
  LOGIN: 'login',
  VALIDATE: 'validate',
  USER: 'me',
  REFRESH: 'refresh',
  LOGOUT: 'logout'
}; 